import { Component, OnInit } from '@angular/core';
import { Globals } from '../../globals'

@Component({
  selector: 'StudentEnrollments',
  templateUrl: './StudentEnrollments.component.html',
})
export class StudentEnrollmentsComponent {
  _myGlobals: Globals;

  constructor(private globals: Globals) {
    this._myGlobals = globals;
  }

}
